module.exports = __webpack_public_path__ + "static/media/map_placeholder.091e57bc.PNG";